import { createContext, useContext } from 'react';
import { DEFAULT_AXIS, type Axis } from './geometry';

/**
 * The board's time axis, shared by every block that draws on it.
 *
 * A context rather than a prop: the axis is one value for the whole board, and
 * threading it through the group → row → block chain would add a parameter to
 * seven components that otherwise have nothing to do with it.
 */
export const AxisContext = createContext<Axis>(DEFAULT_AXIS);

export function useAxis() {
  return useContext(AxisContext);
}
